import React, { useEffect, useState } from "react";
import { LanguageToggle } from "@/coquille-bridge";
import { api, apiJson } from "@/api/client.js";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

export function SettingsPage() {
  const { ui } = useOrignalUi();
  const [info, setInfo] = useState(null);
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [msg, setMsg] = useState("");
  useEffect(() => {
    api("/api/version").then(setInfo).catch(() => {});
  }, []);
  return (
    <main className="og-page" data-testid="page-settings">
      <h1>{ui.settings.title}</h1>
      <p className="og-lead">{ui.settings.subtitle}</p>
      <LanguageToggle testId="orignal-language-toggle" />
      <dl className="og-meta" data-testid="version-block">
        <dt>{ui.settings.version}</dt><dd>{info?.semver || "0.71.0"}</dd>
        <dt>{ui.settings.env}</dt><dd>{info?.env || "local"}</dd>
        <dt>{ui.settings.build}</dt><dd>{info?.build_id || "local"}</dd>
        <dt>{ui.settings.commit}</dt><dd>{info?.commit || "unknown"}</dd>
        <dt>{ui.settings.deployed}</dt><dd>{info?.deployed_at || "—"}</dd>
      </dl>
      <form
        className="og-card og-form"
        data-testid="password-form"
        onSubmit={async (e) => {
          e.preventDefault();
          try {
            await apiJson("/api/auth/change-password", { current_password: current, new_password: next });
            setMsg(ui.app.passwordChanged);
            setCurrent("");
            setNext("");
          } catch {
            setMsg(ui.errors.login);
          }
        }}
      >
        <h3>{ui.app.changePassword}</h3>
        <label>{ui.app.currentPassword}<input className="og-input" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} /></label>
        <label>{ui.app.newPassword}<input className="og-input" type="password" value={next} onChange={(e) => setNext(e.target.value)} /></label>
        <button className="og-btn og-btn--primary" type="submit">{ui.app.save}</button>
        {msg ? <p className="og-hint">{msg}</p> : null}
      </form>
    </main>
  );
}
